import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


/*
 * LIMPA_NOME_PWA_PUSH_V1
 */
if (
  'serviceWorker' in navigator
) {
  window.addEventListener(
    'load',
    () => {
      navigator.serviceWorker
        .register(
          '/service-worker.js'
        )
        .catch(error => {
          console.error(
            '[PWA] Falha ao registrar Service Worker:',
            error
          );
        });
    }
  );
}
